import { createSlice } from '@reduxjs/toolkit';
import AuthService from './AuthService'
import { SessionState, SessionModel } from '../../../types'

const initialState: SessionModel = {
    session: undefined
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        setUser(state, action: { payload: SessionState }) {
            state.session = action.payload;
            if (action.payload != null) {
                AuthService.SetCurrentUser(JSON.stringify(action.payload));
            }
        },
        deleteUser(state, action: { payload: undefined }) {
            state.session = action.payload
        },
    }
});

export const {
    setUser,
    deleteUser
} = userSlice.actions;

export default userSlice.reducer;